(function(window2, factory2) {
  "use strict";
  if (typeof define == "function" && define.amd) {
    define(factory2);
  } else if (typeof module == "object" && module.exports) {
    module.exports = factory2();
  } else {
    window2.matchesSelector = factory2();
  }
})(window, function factory() {
  "use strict";
  var matchesMethod = function() {
    var ElemProto = window.Element.prototype;
    if (ElemProto.matches) {
      return "matches";
    }
    if (ElemProto.matchesSelector) {
      return "matchesSelector";
    }
    var prefixes = ["webkit", "moz", "ms", "o"];
    for (var i = 0; i < prefixes.length; i++) {
      var prefix = prefixes[i];
      var method = prefix + "MatchesSelector";
      if (ElemProto[method]) {
        return method;
      }
    }
  }();
  return function matchesSelector(elem, selector) {
    return elem[matchesMethod](selector);
  };
});
